import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactToPrint from "react-to-print";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { INVENTORY_FUEL_CATEGORY, renderPageStyle } from "../../utils/Utils";
import SignPrintComponent from "../pn/Components/SignPrintComponent";


const INVENTORY_FUEL_CATEGORY_OPTIONS = Object.keys(INVENTORY_FUEL_CATEGORY).map((c) => ({
  label: INVENTORY_FUEL_CATEGORY[c],
  value: c,
}));

const InventorySummary = () => {
  const printRef = useRef();

  const clearPagi = useRef();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    monthYear: searchParams.get('monthYear') || moment().format("YYYY-MM"),
    category: searchParams.get('category') || 'OIL',
  });

  const colTable = [
    {
      Header: "Xe",
      accessor: (item) => item.truckId,
    },
    {
      Header: `Thành tiền ${INVENTORY_FUEL_CATEGORY[filter.category]}(đ)`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.price || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: `${INVENTORY_FUEL_CATEGORY[filter.category]}(lít)`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.consumedInventory || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số km đầu(km)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstDistance || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số km cuối(km)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastDistance || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Số km chạy(km)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.diffDistance || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: `${INVENTORY_FUEL_CATEGORY[filter.category]}/km`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inventoryPerKm || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: `${INVENTORY_FUEL_CATEGORY[filter.category]}/100 km`,
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inventoryPer100Km || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      monthYear: filter.monthYear,
      category: filter.category,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    clearTimeout(clearPagi.current);
    clearPagi.current = setTimeout(() => {
      let params = {
        monthYear: filter.monthYear,
        category: filter.category,
      };

      GET(`/pn/report-truck`, params, true)
        .then(({ data }) => {
          setData([...data.rows]);
          setSummary(data.summary)
        })
        .finally(() => {
          setLoading(false);
        });
    }, 400);
  }, [timeNow, filter]);

  const exportExcel = () => {
    const params = new URLSearchParams({
      monthYear: filter.monthYear,
      category: filter.category,
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/pn/report-truck-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo vận chuyển</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="month"
                          className="form-control  border-primary"
                          value={filter.monthYear}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              monthYear: e.target.value,
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          placeholder="Tìm kiếm loại"
                          classNamePrefix="form-control"
                          options={INVENTORY_FUEL_CATEGORY_OPTIONS}
                          value={INVENTORY_FUEL_CATEGORY_OPTIONS.find(
                            (c) => c.value === filter.category
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              category: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button
                          className={'ml-3'}
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>

                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center mt-2">Báo cáo vận chuyển {INVENTORY_FUEL_CATEGORY[filter.category]} tháng {moment(filter.monthYear, 'YYYY-MM').format('MM-YYYY')}</h5>
                  <style>{renderPageStyle()}</style>
                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td className="nk-tb-col">
                          <span> Tổng </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.price || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <span>
                            <NumericFormat
                              value={summary?.consumedInventory || 0}
                              displayType={'text'}
                              decimalScale={2}
                              thousandSeparator={','}
                              thousandsGroupStyle="thousand"
                            />
                          </span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  ></Table>
                  <SignPrintComponent />
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default InventorySummary;
